// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2N8lQ","errors":"Errors_errors__1xdzI"};